import React from "react";

export default function FormationSelector({
  formations,
  value,
  onChange,
  disabled,
}) {
  return (
    <div className="flex items-center gap-1.5">
      {formations.map((f) => {
        const isActive = f === value;
        return (
          <button
            key={f}
            type="button"
            onClick={() => !disabled && onChange(f)}
            disabled={disabled}
            className={`px-3 py-1 rounded-full text-xs font-semibold tracking-wider transition
              ${
                isActive
                  ? "bg-emerald-500/15 border border-emerald-500/40 text-emerald-300"
                  : "bg-zinc-900/40 border border-zinc-800 text-zinc-400 hover:border-zinc-700 hover:text-zinc-200"
              }
              ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
          >
            {f}
          </button>
        );
      })}
    </div>
  );
}
